var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ContentSlotsDistributor', {
    attrs: {
      "slot-key": _vm.$parent.slotKey
    }
  }, [_c('h2', {
    attrs: {
      "id": "app"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("#")]), _vm._v(" app")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("google driver")]), _vm._v(" "), _c('li', [_vm._v("邮箱大师")]), _vm._v(" "), _c('li', [_vm._v("free download manager")]), _vm._v(" "), _c('li', [_vm._v("微信")]), _vm._v(" "), _c('li', [_vm._v("qq")]), _vm._v(" "), _c('li', [_vm._v("lemon")]), _vm._v(" "), _c('li', [_vm._v("daisydisk")]), _vm._v(" "), _c('li', [_vm._v("jietu")]), _vm._v(" "), _c('li', [_vm._v("tunnelblick")]), _vm._v(" "), _c('li', [_vm._v("utools")]), _vm._v(" "), _c('li', [_vm._v("sougou")]), _vm._v(" "), _c('li', [_vm._v("hammerspoon")]), _vm._v(" "), _c('li', [_vm._v("jd-gui")]), _vm._v(" "), _c('li', [_vm._v("microsoft desktop beta")]), _vm._v(" "), _c('li', [_vm._v("rdm")]), _vm._v(" "), _c('li', [_vm._v("obs")]), _vm._v(" "), _c('li', [_vm._v("charles")]), _vm._v(" "), _c('li', [_vm._v("iterm2")]), _vm._v(" "), _c('li', [_vm._v("datagrip")]), _vm._v(" "), _c('li', [_vm._v("idea")]), _vm._v(" "), _c('li', [_vm._v("sourcetree")]), _vm._v(" "), _c('li', [_vm._v("gcviewer")]), _vm._v(" "), _c('li', [_vm._v("wireshark")]), _vm._v(" "), _c('li', [_vm._v("ObinsKit")]), _vm._v(" "), _c('li', [_vm._v("keeweb")]), _vm._v(" "), _c('li', [_vm._v("youdaodict")]), _vm._v(" "), _c('li', [_vm._v("the unarchiver")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "cli"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#cli"
    }
  }, [_vm._v("#")]), _vm._v(" cli")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("nvm")]), _vm._v(" "), _c('li', [_vm._v("sdkman")]), _vm._v(" "), _c('li', [_vm._v("pyenv")]), _vm._v(" "), _c('li')]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "brew-cask"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#brew-cask"
    }
  }, [_vm._v("#")]), _vm._v(" brew cask")]), _vm._v(" "), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_vm._v("$ brew cask list\nappcleaner                google-backup-and-sync    jetbrains-toolbox         mysql-shell               sourcetree                wireshark\nbaidunetdisk              google-chrome             jietu                     mysqlworkbench            teamviewer                wpsoffice\ncharles                   hammerspoon               keeweb                    postman                   tencent-lemon             xmind\ncheatsheet                iina                      launchrocket              qq                        the-unarchiver\ndaisydisk                 intellij-idea             licecap                   shadowsocksx-ng-r         thunder\ndatagrip                  iterm2                    mailmaster                snip                      tunnelblick\nfree-download-manager     jd-gui                    mongodb-compass           sogouinput                vlc\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("6")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("7")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("8")]), _c('br')])]), _c('h2', {
    attrs: {
      "id": "brew"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#brew"
    }
  }, [_vm._v("#")]), _vm._v(" brew")]), _vm._v(" "), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_vm._v("brew list\nadns\t\t\tgettext\t\t\tlibass\t\t\tlibyaml\t\t\topenssl\t\t\tsuite-sparse\naom\t\t\tgflags\t\t\tlibassuan\t\tlittle-cms2\t\topenssl@1.1\t\tsupervisor\napr\t\t\tgiflib\t\t\tlibbluray\t\tlua\t\t\topus\t\t\ttbb\napr-util\t\t"), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("git")]), _vm._v("\t\t\tlibev\t\t\tlua@5.1\t\t\tp11-kit\t\t\ttelnet\naria2\t\t\tglib\t\t\tlibevent\t\tluarocks\t\tpcre\t\t\ttesseract\nautoconf\t\tglog\t\t\tlibffi\t\t\tlz4\t\t\tpcre2\t\t\tthefuck\nautojump\t\tgmp\t\t\tlibgcrypt\t\tlzo\t\t\tperl\t\t\ttheora\nbrotli\t\t\tgnupg\t\t\tlibgpg-error\t\tmaven\t\t\tpinentry\t\ttree\nc-ares\t\t\tgnutls\t\t\tlibidn2\t\t\tmbedtls\t\t\tpixman\t\t\tunbound\ncairo\t\t\tgradle\t\t\tlibksba\t\t\tmetis\t\t\tpkg-config\t\tutf8proc\nceres-solver\t\tgraphite2\t\tlibmpc\t\t\tmpfr\t\t\tpython\t\t\twebp\ncmake\t\t\tgraphviz\t\tlibogg\t\t\tmycli\t\t\tpython3\t\t\t"), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("wget")]), _vm._v("\ncpanminus\t\tgroovy\t\t\tlibpng\t\t\tmysql\t\t\tpython@2\t\twxmac\ndos2unix\t\tgts\t\t\tlibsamplerate\t\tnetpbm\t\t\tpython@3.8\t\tx264\neigen\t\t\tharfbuzz\t\tlibsndfile\t\tnettle\t\t\treadline\t\tx265\nerlang\t\t\thttpd\t\t\tlibsodium\t\tnghttp2\t\t\tredis\t\t\txvid\nffmpeg\t\t\thugo\t\t\tlibsoxr\t\t\tnpth\t\t\trtmpdump\t\txz\nflac\t\t\ticu4c\t\t\tlibssh2\t\t\tnumpy\t\t\trubberband\t\t"), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("yarn")]), _vm._v("\nfontconfig\t\tilmbase\t\t\tlibtasn1\t\tnvm\t\t\truby\t\t\tyou-get\nfreetype\t\tisl\t\t\tlibtiff\t\t\topenblas\t\tscala\t\t\tyoutube-dl\nfrei0r\t\t\tjansson\t\t\tlibtool\t\t\topencore-amr\t\tsdl2\t\t\tzsh-autosuggestions\nfribidi\t\t\tjasper\t\t\tlibunistring\t\topencv\t\t\tshadowsocks-libev\ngcc\t\t\tjemalloc\t\tlibusb\t\t\topenexr\t\t\tsnappy\ngd\t\t\tjpeg\t\t\tlibvidstab\t\topenjpeg\t\tspeex\ngdbm\t\t\tlame\t\t\tlibvorbis\t\topenresty\t\tsqlite\ngeoip\t\t\tleptonica\t\tlibvpx\t\t\topenresty-openssl\tsubversion\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("6")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("7")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("8")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("9")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("10")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("11")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("12")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("13")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("14")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("15")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("16")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("17")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("18")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("19")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("20")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("21")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("22")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("23")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("24")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("25")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("26")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("27")]), _c('br')])]), _c('h2', {
    attrs: {
      "id": "opt"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#opt"
    }
  }, [_vm._v("#")]), _vm._v(" opt")]), _vm._v(" "), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_vm._v("$ opt "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("ls")]), _vm._v("\naliyun            ant               brook             "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("docker")]), _vm._v("            flutter           jdk               logs              ngrok             protoc            selenium\nandroid           apache-ant-1.10.2 conf              etcd              go                kafka             mongodb           openresty         redis             zk\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br')])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };